import React, { useState } from 'react';
import { BaseConfig } from '../BaseConfig';
import GeneralButtonWithText from '../helpers/GeneralButtonWithText';
import { UIProperties } from '../UIProperties';

const GeneralAlertUI = (props: UIProperties<GeneralAlertUIConfig>) => {
	return (
		<div style={{
			position: 'absolute',
			top: '0',
			left: '0',
			width: '100%',
			height: '100%',
			zIndex: 9000,
			pointerEvents: 'all'
		}} className={' modal-disable-select ' + props.parameters.hideBlackBg? '' : 'modal-bg'}>
			<div style={{
				position: 'absolute',
				top: '50%',
				left: '50%',
				transform: 'translate(-50%, -50%)',
				width: '650px',
				height: '450px'
			}}>
				<img style={{
					width: '100%',
					height: '70px'
				}} src="./assets/images/SBAR/header_modal_1.png"/>
				<div style={{
					position: 'absolute',
					top: '01px',
					left: '3px',
					width: '643px',
					height: '65px',
				}}>
					<p tabIndex={0} id='general-alert-header' style={{
						margin: '0px',
						fontSize: '25pt',
						textAlign: 'center',
						position: 'relative',
						top: '13px'
					}} className="title-font">{props.parameters.title}</p>
				</div>
				
				<div style={{
					width: '100%',
					height: '380px',
					position: 'absolute',
					top: '70px',
					left: '0'
				}}>
					<img style={{
						width: '100%',
						height: '100%'
					}} src="./assets/images/SBAR/window_modal_1_edited.png"/>
					<div style={{
						position: 'absolute',
						top: '20px',
						left: '13px',
						width: '623px',
						height: '265px',
						overflow: 'auto'
					}}>
						<p tabIndex={0} style={{
							margin: '0px',
							fontSize: '16pt',
							textAlign: 'left',
							position: 'relative',
							fontWeight: 'normal'
						}} className="title-font">{props.parameters.text}</p>
					</div>
					<GeneralButtonWithText parameters= {{
						text: props.parameters.okButton.title,
						id: props.parameters.cancelbutton ? '' : 'general-alert-button',
						ariaLbl: props.parameters.okButton.title,
						top: '290px',
						left: props.parameters.cancelbutton ? '160px' : '50%',
						width: '130px',
						isDisabled: false,
						srcIdle: "./assets/images/main-menu/button_menu_exit.png",
						srcHighlight: "./assets/images/main-menu/button_menu_exit_down.png",
						srcDisabled: null,
						customImgStyle: {
						},
						customButtonStyle : {
						},
						customTextStyle: {
							fontSize: '12pt'
						},
						customMainStyle: {
							transform: props.parameters.cancelbutton ? '' : 'translate(-50%, 0)'
						},
						onClicked: props.parameters.okButton.onClicked
					}}/>
					{props.parameters.cancelbutton ? (
						<GeneralButtonWithText parameters= {{
							text: props.parameters.cancelbutton.title,
							id: 'general-alert-button',
							ariaLbl: props.parameters.cancelbutton.title,
							top: '290px',
							left: '350px',
							width: '130px',
							isDisabled: false,
							srcIdle: "./assets/images/main-menu/button_menu_exit.png",
							srcHighlight: "./assets/images/main-menu/button_menu_exit_down.png",
							srcDisabled: null,
							customImgStyle: {
							},
							customButtonStyle : {
							},
							customTextStyle: {
								fontSize: '12pt'
							},
							onClicked: props.parameters.cancelbutton.onClicked
						}}/>
					) : (null)}
					
				</div>
				
			</div>
		</div>
	);

};

export interface GeneralAlertUIConfig extends BaseConfig{
	title: string;
	text: string;
	hideBlackBg?: boolean;
	okButton: GeneralAlertButtonConfig;
	cancelbutton?: GeneralAlertButtonConfig;
}

export interface GeneralAlertButtonConfig {
	title: string;
	onClicked: () => void;
}

export default GeneralAlertUI;